module.exports = __webpack_public_path__ + "img/IMG_5002_L_WoodMatted.0890a21e.jpg";